import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_PUBLIC_ENCRYPTION_KEY as string;

export const encryptData = (data: string) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

export const decryptData = (ciphertext: string) => {
  if (ciphertext) {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  return null;
};

export const encodeValue = (value: string) => {
  return btoa(value);
};
